import React, { ReactNode, RefObject, useCallback, useRef } from 'react';
import Slider, { Settings } from 'react-slick';

interface SlickInnerSlider {
  props: {
    autoplay: boolean;
    autoplaySpeed: number;
  };

  state: {
    currentSlide: number;
    autoplaying: string;
    dragging: boolean;
  };

  autoplayTimer: ReturnType<typeof setInterval> | null;
  play: TimerHandler;

  pause: (type: string) => void;
}

type SliderWithInner = Slider & {
  readonly innerSlider: SlickInnerSlider;
};

export function runAutoPlaySlickReinit(
  sliderRef: RefObject<SliderWithInner | null>,
): void {
  const innerSlider = sliderRef.current?.innerSlider;
  if (innerSlider && !Number.isInteger(innerSlider.state.currentSlide)) {
    innerSlider.state.currentSlide = Math.trunc(innerSlider.state.currentSlide);
  }

  if (innerSlider?.props.autoplay) {
    if (
      innerSlider.state.dragging &&
      innerSlider.state.autoplaying === 'playing'
    ) {
      innerSlider.pause('paused');
    } else if (
      !innerSlider.state.dragging &&
      innerSlider.state.autoplaying !== 'playing'
    ) {
      innerSlider.autoplayTimer && clearInterval(innerSlider.autoplayTimer);
      innerSlider.autoplayTimer = setInterval(
        innerSlider.play,
        innerSlider.props.autoplaySpeed + 50,
      );
      innerSlider.state.autoplaying = 'playing';
    }
  }
}

export type AutoPlaySlickRowProps = {
  settings: Settings;
  className?: string;
  children: ReactNode;
};

const AutoPlaySlickRow: React.FC<AutoPlaySlickRowProps> = ({
  settings,
  className,
  children,
}) => {
  const sliderRef = useRef<SliderWithInner | null>(null);
  const handleReinit = useCallback(() => {
    runAutoPlaySlickReinit(sliderRef);
  }, []);

  return (
    <Slider
      {...settings}
      className={className}
      onReInit={handleReinit}
      ref={sliderRef}
    >
      {children}
    </Slider>
  );
};

export default AutoPlaySlickRow;
